import { useState } from 'react';

const WA_NUMBER = '18492081166';
const WA_URL = `https://wa.me/${WA_NUMBER}?text=Hola%20SpartechRD%2C%20necesito%20información.`;

export default function FloatingWhatsApp() {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="nofollow noreferrer"
      title="Chatear por WhatsApp"
      aria-label="Contactar por WhatsApp"
      className="fixed left-3 sm:left-5 z-50 flex items-center cursor-pointer group"
      style={{
        bottom: '72px',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <style>{`
        @keyframes waPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(34,197,94,0.4); }
          50%       { box-shadow: 0 0 0 8px rgba(34,197,94,0); }
        }
        .wa-pulse { animation: waPulse 2.4s ease-in-out infinite; }
      `}</style>

      {/* Expandable label — slides in from the left on hover */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-out ${
          hovered ? 'max-w-[120px] opacity-100 mr-2' : 'max-w-0 opacity-0 mr-0'
        }`}
      >
        <span className="bg-emerald-500 text-white text-xs font-bold px-3 py-2 rounded-full whitespace-nowrap shadow-md block">
          WhatsApp
        </span>
      </div>

      {/* Main button */}
      <div
        className={`wa-pulse w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center rounded-full transition-all duration-200 flex-shrink-0 ${
          hovered ? 'scale-110' : 'scale-100'
        }`}
        style={{
          background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
          boxShadow: '0 4px 16px rgba(34,197,94,0.35)',
        }}
      >
        <i className="ri-whatsapp-line text-white text-xl sm:text-2xl" />
      </div>
    </a>
  );
}
